import {Button, Col, Form, Row} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import {IUpdateMarketingProfile, ProfileInterests} from 'modules/marketing-profile/models/marketing-profile';

const studentRegistrationExtraInfoSchema = Yup.object().shape({
    interests: Yup.array(Yup.string().oneOf(Object.values(ProfileInterests))).min(1),
});

interface IStudentRegistrationExtraInfoProps {
    isSubmitting: boolean;
    formData: IUpdateMarketingProfile;
    onSetData: (data: IUpdateMarketingProfile) => void;
    onPreviousStep: () => void;
    onSubmit: (data: IUpdateMarketingProfile) => void;
}

export const StudentRegistrationExtraInfo = ({isSubmitting, formData, onSetData, onPreviousStep, onSubmit}: IStudentRegistrationExtraInfoProps) => {
    const {t} = useTranslation();

    const {handleSubmit, register, getValues} = useForm<IUpdateMarketingProfile>({
        resolver: yupResolver(studentRegistrationExtraInfoSchema),
        defaultValues: formData,
    });

    const onBack = () => {
        onSetData({...formData, ...getValues()});
        onPreviousStep();
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <fieldset className="mb-3">
                <Form.Group className="mb-3">
                    <Form.Label className="h3">Interests</Form.Label>
                    <Form.Text className="text-muted">
                        Please select all that apply
                    </Form.Text>
                    <Row>
                        {Object.values(ProfileInterests).map((interest, index) => (
                            <Col sm={6} key={interest}>
                                <Form.Check
                                    id={interest}
                                    type="checkbox"
                                    label={interest.charAt(0).toUpperCase() + interest.slice(1).toLowerCase()}
                                    style={{fontSize: '1.15rem'}}
                                    value={interest}
                                    {...register('interests')}
                                />
                            </Col>
                        ))}
                    </Row>
                </Form.Group>
            </fieldset>
            <div className="d-flex mt-4">
                <Button
                    className='m-0 mr-auto'
                    variant="secondary"
                    onClick={onBack}
                    size="lg"
                    style={{margin: '0 auto', display: 'block', fontSize: 'larger'}}
                    disabled={isSubmitting}
                >
                    {t('common.back', 'Back')}
                </Button>
                <Button
                    className='m-0'
                    variant="primary"
                    type="submit"
                    size="lg"
                    style={{margin: '0 auto', display: 'block', fontSize: 'larger'}}
                    disabled={isSubmitting}
                >
                    {t('common.submit', 'Submit')}
                </Button>
            </div>
        </Form>
    );
};